import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import { Edges } from '../../../styles/Grid/GridSizes';

export const containerPaddingCss = css({
  paddingTop: 48,
  [MediaQueries.md]: {
    paddingTop: 80,
  },
  [MediaQueries.lgAndUp]: {
    paddingTop: 128,
  },
});

export const containerWhiteSpaceCss = css({
  position: 'relative',
  '&:after': {
    content: "''",
    position: 'absolute',
    width: '100%',
    zIndex: 1,
    background: colorsPalette.white,
    bottom: 0,
    height: 115,
    [MediaQueries.md]: {
      height: 130,
    },
    [MediaQueries.lg]: {
      height: 200,
    },
    [MediaQueries.xl]: {
      height: 330,
    },
  },
});

export const upperHeadlineCss = css(typography.effra14, {
  marginBottom: 24,
  [MediaQueries.mdAndUp]: {
    ...typography.effra18,
    marginBottom: 32,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 24,
  },
});

export const headlineCss = css(typography.effra100, {
  color: colorsPalette.black,
  fontWeight: fontWeights.medium,
  marginTop: 0,
  marginBottom: 26,
  [MediaQueries.mdAndUp]: {
    marginBottom: 36,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 48,
  },
});

export const bodyCss = css(typography.effra16, {
  color: colorsPalette.grey80,
  marginBottom: 32,
  [MediaQueries.md]: {
    marginBottom: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 32,
  },
});

export const discoverCss = css({
  paddingLeft: 20,
  display: 'none',
  [MediaQueries.mdAndUp]: {
    display: 'block',
    position: 'relative',
  },
});

export const separatorCss = css({
  display: 'inline-block',
  margin: '0 8px',
  borderBottom: `1px solid ${colorsPalette.grey50}`,
  width: 10,
  height: 1,
  verticalAlign: 'middle',
  [MediaQueries.mdAndUp]: {
    margin: '0 15px',
  },
});

export const ctasContainerCss = css({
  [MediaQueries.mdAndUp]: {
    marginBottom: 65,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 80,
  },
});

export const phoneWrapperCss = css({
  height: 88,
  display: 'flex',
  alignItems: 'center',
  [MediaQueries.mdAndUp]: {
    margin: 0,
    height: 56,
  },
});

export const findWorkspaceCss = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const rotatorCss = css({
  transform: 'rotate(-90deg)',
  [MediaQueries.mdAndUp]: {
    marginLeft: -30,
  },
});

export const arrowCss = css({
  color: colorsPalette.black,
  display: 'inline-block',
  verticalAlign: 'middle',
  [MediaQueries.mdAndUp]: {
    marginRight: 35,
    marginLeft: -40,
  },
});

export const discoverTextCss = css({
  color: colorsPalette.grey80,
  whiteSpace: 'nowrap',
});

export const discoverRegusTextCss = css({
  position: 'sticky',
  zIndex: 2,
  [MediaQueries.md]: {
    top: 'calc(100% - 156px)',
  },
  [MediaQueries.lg]: {
    top: 'calc(100% - 149px)',
  },
  [MediaQueries.xl]: {
    top: 'calc(100% - 173px)',
  },
});

export const discoverRegusTextIECss = css({
  position: 'absolute',
});

export const imageContainerCss = css({
  marginRight: `-${Edges.sm}px`,
  [MediaQueries.md]: {
    marginRight: `-${Edges.md}px`,
  },
  [MediaQueries.lg]: {
    marginRight: `-${Edges.lg}px`,
  },
  [MediaQueries.xl]: {
    marginRight: `-${Edges.xl}px`,
  },
});

export const imageCss = css({
  position: 'relative',
  zIndex: 2,
  width: '100%',
  height: 'auto',
  img: {
    width: '100%',
  },
});

export const customSpacerCss = css({
  [MediaQueries.lgAndUp]: {
    marginBottom: 120,
  },
});

export const searchIconCss = css({
  marginRight: 10,
  pointerEvents: 'none',
  verticalAlign: 'bottom',
  fontSize: 16,
});

export const disableEventOnTextCss = css({
  pointerEvents: 'none',
});
